import { render, staticRenderFns } from "./autoCompleteFrequenciaSaida.vue?vue&type=template&id=25263dde&scoped=true"
import script from "./autoCompleteFrequenciaSaida.vue?vue&type=script&setup=true&lang=js"
export * from "./autoCompleteFrequenciaSaida.vue?vue&type=script&setup=true&lang=js"
import style0 from "./autoCompleteFrequenciaSaida.vue?vue&type=style&index=0&id=25263dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25263dde",
  null
  
)

export default component.exports